"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDelayedTask = void 0;
class IkeDelayedTask {
    constructor(func, ms = 0) {
        this.timeoutId = null;
        /** The next time this function is scheduled to run */
        this.nextTime = null;
        this.func = func;
        this.ms = ms;
    }
    get isActive() {
        return this.timeoutId != null;
    }
    delay(ms = this.ms) {
        var _a;
        const nextTime = Date.now() + ms;
        // Don't re-make the timeout if the next timeout is within X ms
        if (this.isActive) {
            const diffTime = Math.abs(nextTime - ((_a = this.nextTime) !== null && _a !== void 0 ? _a : 0));
            if (diffTime < 5) {
                return;
            }
        }
        this.cancel();
        this.timeoutId = setTimeout(this.func, ms);
        this.nextTime = nextTime;
    }
    run() {
        this.cancel();
        this.func();
    }
    cancel() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = null;
        this.nextTime = null;
    }
}
exports.IkeDelayedTask = IkeDelayedTask;
//# sourceMappingURL=delayed.task.js.map